import { isNumber, pickBy } from 'lodash';

import Text from '~/common/components/Texts/Text';
import { formatCurrency } from '~/common/util/format';

const OverridenIncomeLabelMap = {
  overriddenBaseIncome: 'Manually Updated Monthly Base Income:',
  overriddenBonusIncome: 'Manually Updated Monthly Bonus Income:',
  overriddenCommissionIncome: 'Manually Updated Monthly Commission Income:',
  overriddenNetRentalIncome: 'Manually Updated Monthly Net Rental Income:',
  overriddenOtherIncome: 'Manually Updated Monthly Other Income:',
  overriddenOvertimeIncome: 'Manually Updated Monthly Overtime Income:',
  overriddenSeasonalIncome: 'Manually Updated Monthly Seasonal Income:',
  overriddenTipIncome: 'Manually Updated Monthly Tip Income:',
  default: 'Manually Updated Monthly Income:',
} as const;

type OverridenIncomesProps = {
  possibleOverrides: Partial<
    Record<keyof typeof OverridenIncomeLabelMap, number>
  >;
};

const OverridenIncomes = ({ possibleOverrides }: OverridenIncomesProps) => {
  const overridenAmounts = pickBy(
    possibleOverrides,
    (value) => isNumber(value) && value !== 0,
  );

  if (Object.keys(overridenAmounts).length === 0) {
    return null;
  }

  return (
    <>
      {Object.keys(overridenAmounts).map((overrideKey) => (
        <Text mb={4} key={overrideKey}>
          <Text as="span" fontWeight={500}>
            {OverridenIncomeLabelMap[overrideKey] ??
              OverridenIncomeLabelMap.default}
            &nbsp;
          </Text>
          {formatCurrency(overridenAmounts[overrideKey])}
        </Text>
      ))}
    </>
  );
};

export default OverridenIncomes;
